
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';

const classNames = mergeStyleSets({
    root: {
        width: '100%',
        height: '50vh',
        boxShadow: '0px 0px 4px rgb(0, 0, 0, 0.5)',
    }
})

const MapView = ({
    componentMap
}) => {

    return (
        <div className={classNames.root}>
            <div style={{display: 'flex', width:'100%', height:'100%'}}>{componentMap}</div>
        </div>
    )
}

export default MapView;
